import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();
const BASE = "/forms";

// ── Thunks ─────────────────────────────────────────────────────────
export const fetchForms = createAsyncThunk("leadForms/fetchForms",
  async () => api.get(BASE)
);

export const fetchForm = createAsyncThunk("leadForms/fetchForm",
  async (id) => api.get(`${BASE}/${id}`)
);

export const createForm = createAsyncThunk("leadForms/createForm",
  async (data) => api.create(BASE, data || {})
);

export const updateForm = createAsyncThunk("leadForms/updateForm",
  async ({ id, data }) => api.put(`${BASE}/${id}`, data)
);

export const deleteForm = createAsyncThunk("leadForms/deleteForm",
  async (id) => { await api.delete(`${BASE}/${id}`); return id; }
);

export const fetchSubmissions = createAsyncThunk("leadForms/fetchSubmissions",
  async (id) => api.get(`${BASE}/${id}/submissions`)
);

const slice = createSlice({
  name: "leadForms",
  initialState: {
    items: [],
    current: null,
    submissions: [],
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchForms.pending, (s) => { s.loading = true; s.error = null; })
     .addCase(fetchForms.fulfilled, (s, a) => { s.loading = false; s.items = a.payload || []; })
     .addCase(fetchForms.rejected, (s, a) => { s.loading = false; s.error = a.error?.message; })

     .addCase(fetchForm.pending, (s) => { s.loading = true; })
     .addCase(fetchForm.fulfilled, (s, a) => { s.loading = false; s.current = a.payload; })
     .addCase(fetchForm.rejected, (s, a) => { s.loading = false; s.error = a.error?.message; })

     .addCase(createForm.pending, (s) => { s.saving = true; })
     .addCase(createForm.fulfilled, (s, a) => {
       s.saving = false;
       s.current = a.payload;
       s.items = [a.payload, ...(s.items || [])];
     })
     .addCase(createForm.rejected, (s, a) => { s.saving = false; s.error = a.error?.message; })

     .addCase(updateForm.pending, (s) => { s.saving = true; })
     .addCase(updateForm.fulfilled, (s, a) => {
       s.saving = false;
       s.current = a.payload;
       s.items = (s.items || []).map((f) => f.id === a.payload.id ? a.payload : f);
     })
     .addCase(updateForm.rejected, (s, a) => { s.saving = false; s.error = a.error?.message; })

     .addCase(deleteForm.fulfilled, (s, a) => {
       s.items = (s.items || []).filter((f) => f.id !== a.payload);
     })

     .addCase(fetchSubmissions.fulfilled, (s, a) => { s.submissions = a.payload || []; });
  },
});

export default slice.reducer;
